import { orderStatusOptionsNew, productTypeOptions } from "constants/SelectFieldOptions"
import { UITypes } from "types"
import ProductType from "types/enums/ProductType"

import OrderNumberCell from "components/table/columnComponents/OrderNumberCell"
import OrdersQuantity from "components/table/columnComponents/OrdersQuantity"
import RowExpandToggle from "components/table/columnComponents/RowExpandToggle"
import { StatusOfOrderNew } from "components/table/columnComponents/StatusOfOrderNew"

export const enterpriseOrdersTableHeaderCells: UITypes.TableHeaderCell[] = [
  {
    title: "",
    name: "group_toggle",
    cellComponent: RowExpandToggle,
    size: "mini",
  },
  {
    title: "Order Number",
    type: "search-number",
    name: "item_id",
    size: "middle",
    cellComponent: OrderNumberCell,
  },
  {
    title: "Creation Date",
    type: "sort-date-range",
    name: "create_date",
    size: "small",
  },
  {
    title: "Contractor",
    type: "sort-search",
    name: "company_name",
    size: "middle",
  },
  {
    title: "Thermostat",
    type: "select",
    name: "product_type",
    size: "middle",
    options: productTypeOptions.filter(option => [ProductType.Thermostat, ProductType.CWA].includes(option.value)),
  },
  {
    title: "Qty",
    type: "search-number",
    name: "quantity",
    size: "small",
    cellComponent: OrdersQuantity,
    cellComponentProps: {
      isVendor: true,
    },
  },
  {
    title: "Warehouse",
    type: "search",
    name: "warehouse",
    size: "middle",
  },
  {
    title: "Status",
    type: "select",
    name: "item_status",
    size: "middle",
    options: orderStatusOptionsNew,
    cellComponent: StatusOfOrderNew,
  },
]
